import { MdOutlineLink } from 'react-icons/md';
import CopyToClipboard from 'legacy/common/components/copy-to-clipboard/CopyToClipboard';

type TrackingLinkProps = { trackingLink: any };

const TrackingLink: React.FC<TrackingLinkProps> = ({ trackingLink }) => {
  const link = `${window.location.origin}${trackingLink.pathname}`;
  return (
    <>
      <div className="flex items-center">
        <MdOutlineLink className="mr-2" size={24} />
        <h2 className="text-base font-semibold">{trackingLink.name}</h2>
      </div>
      <div className="flex mt-3 items-center">
        <div className="w-full border-1 border-gray-200 rounded-2xl px-4 py-2">
          <input className="w-full text-gray-400 truncate" value={link} />
        </div>
        <div className="w-[100px] ml-4">
          <CopyToClipboard message="Copy" copyText={link} />
        </div>
      </div>
    </>
  );
};
export default TrackingLink;
